
export enum GliderFileImportStep  {
  IrisStarting ='IrisStarting',
  IrisRunning = 'IrisRunning',
  IrisFinished = 'IrisFinished',
  IrisAborted = 'IrisAborted',
  HttpRunning = 'HttpRunning',
  HttpFinished = 'HttpFinished',
  HttpFailed = 'HttpFailed',
  UnzippingRunning = 'UnzippingRunning',
  UnzippingFinished = 'UnzippingFinished',
  UnzippingFailed = 'UnzippingFailed',
  StagingRunning = 'StagingRunning',
  StagingFinished = 'StagingFinished',
  StagingFailed = 'StagingFailed',
  IndexingRunning = 'IndexingRunning',
  IndexingFinished = 'IndexingFinished',
  IndexingFailed = 'IndexingFailed',
  CacheGraphRunning = 'CacheGraphRunning',
  CacheGraphFinished  = 'CacheGraphFinished'
}